import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "unlink",
  "description": "`turbo unlink` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "断开存储库与远程缓存的连接。"
  }, {
    "heading": "",
    "content": "¥Disconnect the repository from Remote Cache."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "断开存储库与远程缓存的连接。"
    }), "\n", _jsx(_components.p, {
      children: "¥Disconnect the repository from Remote Cache."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " unlink"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
